import React, { useState, useEffect } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';

import { Text } from 'bohr-web';
import FlatButton from 'components/UI/FlatButton/FlatButton';

import CallIcon from '@material-ui/icons/Call';
import CEAvatar from './images/ce-avatar.png';
import SEAvatar from './images/se-avatar.png';
import FastagLogo from './images/fastag.svg';

import './Teammate.scss';
import STRINGS from './Constants';

import { getTeammates } from './utils/api';
import firebase from 'firebase/app';

const Teammate = () => {
  const [locale] = useQueryParam('locale', StringParam);
  const [token] = useQueryParam('token', StringParam);
  const [serviceTypes] = useQueryParam('serviceTypes', StringParam);
  const [teammates, setTeammates] = useState([]);

  useEffect(() => {
    const acceptedServices = !!serviceTypes ? serviceTypes.split(',') : [];
    getTeammates(token, serviceTypes).then((response) => {
      processTeammates(response, acceptedServices);
    });
  }, [token, serviceTypes]);

  const processTeammates = (response, acceptedServices) => {
    if (!response || !response.data || !response.data.data) {
      setTeammates([]);
    } else {
      const teammatesArray = response.data.data;
      if (teammatesArray.length === 0) {
        setTeammates([]);
      } else {
        teammatesArray.filter((teammate) => {
          for (const acceptedService of acceptedServices) {
            for (const teammateService of teammate.services) {
              if (teammateService === acceptedService) {
                return true;
              }
            }
          }
          return false;
        });
        setTeammates(teammatesArray);
      }
    }
  };

  const recordEvent = (eventName) => {
    // Setting User Properties in Firebase
    firebase.analytics().setUserId(token);
    firebase.analytics().logEvent(eventName);
  };

  return (
    <div className="teammate-wrapper">
      <div className="logo">
        <img src={FastagLogo} alt="Logo" />
      </div>
      <Text text={STRINGS(locale).Title} size="header2" variant="semiBold" />
      {teammates.map((teammate, index) => {
        return (
          <div key={index} className="details-row-wrapper">
            <div className="details-wrapper">
              {/* <div className="avatar-column">
                <img src={SEAvatar} alt="" />
              </div> */}
              <div className="contact-column">
                <Text
                  text={teammate.name + STRINGS(locale).SETitle}
                  size="regular"
                  color="bodyTextDark"
                  referenceClass="details-row"
                />
                <Text
                  text={teammate.phone}
                  size="regular"
                  color="bodyTextLight"
                  referenceClass="details-row"
                  variant="light"
                />
              </div>
            </div>
            <a className="full-button" href={'tel:' + teammate.phone}>
              <FlatButton
                height="3rem"
                textcolor="#ffffff"
                backgroundcolor="#d83808"
                bordercolor="#d83808"
                hoverbackgroundcolor="#ad2d06"
                startIcon={<CallIcon />}
                onClick={recordEvent(STRINGS(locale).EventCallSalesExecutive)}
              >
                {STRINGS(locale).CallButton}
              </FlatButton>
            </a>
          </div>
        );
      })}
      <div className="details-row-wrapper">
        <div className="details-wrapper">
          {/* <div className="avatar-column">
            <img src={CEAvatar} alt="" />
          </div> */}
          <div className="contact-column">
            <Text text={STRINGS(locale).CETitle} size="regular" color="bodyTextDark" referenceClass="details-row" />
            <Text
              text={STRINGS(locale).CENumber}
              size="regular"
              color="bodyTextLight"
              referenceClass="details-row"
              variant="light"
            />
          </div>
        </div>
        <a className="full-button" href="tel:9990033455">
          <FlatButton
            height="3rem"
            textcolor="#d83808"
            hovertextcolor="#ffffff"
            backgroundcolor="#ffffff"
            bordercolor="#d83808"
            hoverbackgroundcolor="#ad2d06"
            startIcon={<CallIcon />}
            onClick={recordEvent(STRINGS(locale).EventCallCustomerSupport)}
          >
            {STRINGS(locale).CallButton}
          </FlatButton>
        </a>
      </div>
    </div>
  );
};

export default Teammate;
